export default {
  getWeather: url => ({
    url: `/nmc-weather${url}`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Crawler.js